// @generated by protoc-gen-es v1.0.0 with parameter "target=js+dts,ts_nocheck=false"
// @generated from file api/scribe/svc_encounter.proto (package com.diagnocat.scribe, syntax proto3)
/* eslint-disable */

import { proto3, Timestamp } from "@bufbuild/protobuf";
import { DocumentEditIssueType, Encounter, EncounterPreview } from "../../model/dto_scribe_encounter_pb.js";

/**
 * @generated from message com.diagnocat.scribe.GetEncounterReq
 */
export const GetEncounterReq = proto3.makeMessageType(
  "com.diagnocat.scribe.GetEncounterReq",
  () => [
    { no: 1, name: "EncounterID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "ResolvePatientInfo", kind: "scalar", T: 8 /* ScalarType.BOOL */, opt: true },
  ],
);

/**
 * @generated from message com.diagnocat.scribe.GetEncounterResp
 */
export const GetEncounterResp = proto3.makeMessageType(
  "com.diagnocat.scribe.GetEncounterResp",
  () => [
    { no: 1, name: "Encounter", kind: "message", T: Encounter },
  ],
);

/**
 * At least one of PatientID or OrganizationID is required.
 *
 * @generated from message com.diagnocat.scribe.ListEncountersReq
 */
export const ListEncountersReq = proto3.makeMessageType(
  "com.diagnocat.scribe.ListEncountersReq",
  () => [
    { no: 1, name: "PatientID", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 2, name: "OrganizationID", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 3, name: "SchemaCode", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 6, name: "ExternalID", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 7, name: "UpdatedAfter", kind: "message", T: Timestamp, opt: true },
    { no: 8, name: "UpdatedAfterID", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 9, name: "IncludeArchived", kind: "scalar", T: 8 /* ScalarType.BOOL */, opt: true },
    { no: 4, name: "IncludeDeleted", kind: "scalar", T: 8 /* ScalarType.BOOL */, opt: true },
    { no: 5, name: "ResolvePatientInfo", kind: "scalar", T: 8 /* ScalarType.BOOL */, opt: true },
    { no: 100, name: "Offset", kind: "scalar", T: 13 /* ScalarType.UINT32 */, opt: true },
    { no: 101, name: "Limit", kind: "scalar", T: 13 /* ScalarType.UINT32 */, opt: true },
  ],
);

/**
 * @generated from message com.diagnocat.scribe.ListEncountersResp
 */
export const ListEncountersResp = proto3.makeMessageType(
  "com.diagnocat.scribe.ListEncountersResp",
  () => [
    { no: 1, name: "Encounters", kind: "message", T: EncounterPreview, repeated: true },
    { no: 2, name: "Total", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
  ],
);

/**
 * Fields left unset keep their stored value.
 *
 * @generated from message com.diagnocat.scribe.UpdateEncounterReq
 */
export const UpdateEncounterReq = proto3.makeMessageType(
  "com.diagnocat.scribe.UpdateEncounterReq",
  () => [
    { no: 1, name: "EncounterID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "UserID", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 4, name: "StaffMemberID", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 5, name: "PatientID", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
  ],
);

/**
 * @generated from message com.diagnocat.scribe.UpdateEncounterResp
 */
export const UpdateEncounterResp = proto3.makeMessageType(
  "com.diagnocat.scribe.UpdateEncounterResp",
  [],
);

/**
 * @generated from message com.diagnocat.scribe.ArchiveEncounterReq
 */
export const ArchiveEncounterReq = proto3.makeMessageType(
  "com.diagnocat.scribe.ArchiveEncounterReq",
  () => [
    { no: 1, name: "EncounterID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message com.diagnocat.scribe.ArchiveEncounterResp
 */
export const ArchiveEncounterResp = proto3.makeMessageType(
  "com.diagnocat.scribe.ArchiveEncounterResp",
  [],
);

/**
 * @generated from message com.diagnocat.scribe.RestoreEncounterReq
 */
export const RestoreEncounterReq = proto3.makeMessageType(
  "com.diagnocat.scribe.RestoreEncounterReq",
  () => [
    { no: 1, name: "EncounterID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message com.diagnocat.scribe.RestoreEncounterResp
 */
export const RestoreEncounterResp = proto3.makeMessageType(
  "com.diagnocat.scribe.RestoreEncounterResp",
  [],
);

/**
 * @generated from message com.diagnocat.scribe.DeleteEncounterReq
 */
export const DeleteEncounterReq = proto3.makeMessageType(
  "com.diagnocat.scribe.DeleteEncounterReq",
  () => [
    { no: 1, name: "EncounterID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message com.diagnocat.scribe.DeleteEncounterResp
 */
export const DeleteEncounterResp = proto3.makeMessageType(
  "com.diagnocat.scribe.DeleteEncounterResp",
  [],
);

/**
 * @generated from message com.diagnocat.scribe.UpdateEncounterDocumentReq
 */
export const UpdateEncounterDocumentReq = proto3.makeMessageType(
  "com.diagnocat.scribe.UpdateEncounterDocumentReq",
  () => [
    { no: 1, name: "EncounterID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "DocumentID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "Sections", kind: "message", T: EncounterDocumentSectionUpdate, repeated: true },
    { no: 4, name: "Approved", kind: "scalar", T: 8 /* ScalarType.BOOL */, opt: true },
  ],
);

/**
 * @generated from message com.diagnocat.scribe.UpdateEncounterDocumentResp
 */
export const UpdateEncounterDocumentResp = proto3.makeMessageType(
  "com.diagnocat.scribe.UpdateEncounterDocumentResp",
  [],
);

/**
 * @generated from message com.diagnocat.scribe.EncounterDocumentSectionUpdate
 */
export const EncounterDocumentSectionUpdate = proto3.makeMessageType(
  "com.diagnocat.scribe.EncounterDocumentSectionUpdate",
  () => [
    { no: 1, name: "Code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "Content", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 3, name: "IssueTypes", kind: "enum", T: proto3.getEnumType(DocumentEditIssueType), repeated: true },
    { no: 4, name: "FeedbackText", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
  ],
);

